"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[799,379],{

/***/ 5219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Loading/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &,\n  &:after {\n    border-radius: 50%;\n    width: 18px;\n    height: 18px;\n    background-color: transparent;\n  }\n  & {\n    font-size: 10px;\n    position: relative;\n    text-indent: -9999em;\n    border-top: 2px solid rgba(255, 255, 255, 0.2);\n    border-right: 2px solid rgba(255, 255, 255, 0.2);\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n    border-left: 2px solid #ffffff;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-animation: load8 1.1s infinite linear;\n    animation: load8 1.1s infinite linear;\n  }\n\n  @-webkit-keyframes load8 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes load8 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-51956618-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/themes/default/components/Loading/index.tsx


const Loading = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {});
};

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 9 modules
var polished_esm = __webpack_require__(6637);
;// CONCATENATED MODULE: ./src/themes/default/components/Button/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: #fff;\n          color: ",
        ";\n\n          &:not(:disabled):hover {\n            filter: brightness(0.93);\n          }\n        "
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  color: ",
        ";\n                "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          &:not(:disabled):hover {\n            ",
        "\n          }\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n  border: ",
        ";\n  border-radius: ",
        ";\n\n  font-weight: 500;\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  font-size: ",
        ";\n  padding: ",
        ";\n\n  line-height: ",
        ";\n\n  transition: color 0.3s, background-color 0.3s, filter ease-in 0.3s;\n  will-change: color, background-color;\n\n  width: ",
        ";\n\n  height: 36px;\n\n  ",
        "\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-cf07a0ae-0"
})(_templateObject4(), (p)=>"1px solid ".concat(p.transparent ? "transparent" : p.theme.colors[p.color]), (p)=>p.theme.borderRadius, (p)=>p.transparent ? "transparent" : p.theme.colors[p.color], (p)=>p.transparent ? p.theme.colors[p.color] : (0,polished_esm/* readableColor */.XV)((0,polished_esm/* darken */._j)(0.22, p.theme.colors[p.color]), p.theme.colors.textDark, p.theme.colors.textLight), (p)=>p.theme.font[p.font], (p)=>p.theme.button[p.size], (p)=>p.lineHeight && p.theme.spacing[p.lineHeight], (p)=>p.width ? "".concat(p.width * 100, "% !important") : "", (param)=>{
    let { theme , variant , color , transparent  } = param;
    return variant === "outlined" ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), theme.colors[color]) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), transparent ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), (0,polished_esm/* transparentize */.DZ)(0.15, theme.colors[color])) : (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), (0,polished_esm/* transparentize */.DZ)(0.15, theme.colors[color])));
});

;// CONCATENATED MODULE: ./src/themes/default/components/Button/index.tsx



const Button = (param)=>{
    let { children , size ="medium" , color ="primary" , font ="medium" , lineHeight , type , width , transparent , onClick , isLoading , disabled , variant ="default"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
        disabled: isLoading || disabled,
        transparent: transparent,
        size: size,
        font: font,
        color: color,
        lineHeight: lineHeight,
        type: type,
        width: width,
        onClick: onClick,
        variant: variant,
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}) : children
    });
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_ProductsList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/LoadingSkeleton/CardSkeleton/components/Rating/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  font-size: ",
        ";\n  align-items: center;\n  justify-content: center;\n\n  & svg {\n    stroke-width: 1.2px;\n    fill: ",
        ";\n\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d7f9c30a-0"
})(_templateObject(), (p)=>p.theme.spacing.nano, (p)=>p.theme.font.medium, (p)=>p.theme.colors.backgroundHover, (p)=>p.theme.colors.backgroundHover);

;// CONCATENATED MODULE: ./src/themes/default/components/LoadingSkeleton/CardSkeleton/components/Rating/index.tsx



const Rating = (param)=>{
    let { value =0  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 1 && {
                    className: "filled"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 2 && {
                    className: "filled"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 3 && {
                    className: "filled"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 4 && {
                    className: "filled"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 5 && {
                    className: "filled"
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/themes/default/components/LoadingSkeleton/CardSkeleton/styles.ts

function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  opacity: 0;\n\n  transition: opacity 0.3s;\n  will-change: opacity;\n\n  margin-top: auto;\n\n  @media (max-width: 768px) {\n    opacity: 1;\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  width: 100%;\n  background-color: ",
        ";\n\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n\n  padding: 10px;\n  gap: 10px;\n\n  border-radius: ",
        ";\n\n  text-align: center;\n\n  transition: box-shadow 0.3s, transform 0.3s;\n  will-change: box-shadow, transform;\n\n  &:hover {\n    transform: translateY(-",
        ");\n    box-shadow: 0 3px 11.83px 1.17px rgb(0 0 0 / 15%);\n\n    ",
        " {\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 100%;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  border-radius: ",
        ";\n\n  background-color: ",
        ";\n\n  background-size: 50% 100%;\n  background-repeat: no-repeat;\n  background-image: linear-gradient(\n    90deg,\n    rgb(238, 238, 238),\n    rgb(245, 245, 245),\n    rgb(238, 238, 238)\n  );\n\n  animation: 1s ease-in-out 0s infinite normal none running skeleton;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: 300;\n\n  margin: 0 auto;\n\n  user-select: none;\n  border-radius: ",
        ";\n\n  background-color: ",
        ";\n  color: transparent;\n\n  background-size: 50% 100%;\n  background-repeat: no-repeat;\n  background-image: linear-gradient(\n    90deg,\n    rgb(238, 238, 238),\n    rgb(245, 245, 245),\n    rgb(238, 238, 238)\n  );\n\n  animation: 1s ease-in-out 0s infinite normal none running skeleton;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n\n  margin: 0 auto;\n\n  user-select: none;\n  border-radius: ",
        ";\n\n  background-color: ",
        ";\n  color: transparent;\n\n  background-size: 50% 100%;\n  background-repeat: no-repeat;\n  background-image: linear-gradient(\n    90deg,\n    rgb(238, 238, 238),\n    rgb(245, 245, 245),\n    rgb(238, 238, 238)\n  );\n\n  animation: 1s ease-in-out 0s infinite normal none running skeleton;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        ";\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: ",
        ";\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}

const WrapperAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-0"
})(styles_templateObject());
const styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-1"
})(_templateObject1(), (p)=>p.theme.colors.background, (p)=>p.theme.borderRadius, (p)=>p.theme.spacing.small, WrapperAction);
const Proportional = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-2"
})(_templateObject2());
const WrapperImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-3"
})(_templateObject3(), (p)=>p.theme.borderRadius, (p)=>p.theme.colors.loadingHover);
const WrapperContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-4"
})(_templateObject4(), (p)=>p.theme.spacing.small);
const Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-5"
})(_templateObject5(), (p)=>p.theme.font.small, (p)=>p.theme.borderRadius, (p)=>p.theme.colors.loadingHover);
const Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-6"
})(_templateObject6(), (p)=>p.theme.font.medium, (p)=>p.theme.borderRadius, (p)=>p.theme.colors.loadingHover);
const Flag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-7"
})(_templateObject7(), (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.primary, (p)=>p.theme.colors.textLight, (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.small, (p)=>p.theme.borderRadius);
const Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1a66eecf-8"
})(_templateObject8(), (p)=>p.theme.colors.textSecondary);
const WrapperPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a66eecf-9"
})(_templateObject9(), (p)=>p.theme.spacing.small);

;// CONCATENATED MODULE: ./src/themes/default/components/LoadingSkeleton/CardSkeleton/index.tsx



const CardSkeleton = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Proportional, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperImage, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating, {
                value: 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "Carregando T\xedtulo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperPrice, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                            children: "R$ 0,00"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LoadingSkeleton_CardSkeleton = (CardSkeleton);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./src/themes/default/components/Button/index.tsx + 3 modules
var Button = __webpack_require__(5219);
// EXTERNAL MODULE: ./src/hooks/useSiteSettings.tsx + 1 modules
var useSiteSettings = __webpack_require__(1371);
// EXTERNAL MODULE: ./src/utils/formatCurrency.ts
var formatCurrency = __webpack_require__(2894);
;// CONCATENATED MODULE: ./src/themes/default/components/Card/components/Rating/styles.ts

function Rating_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  font-size: ",
        ";\n  align-items: center;\n  justify-content: center;\n\n  color: ",
        ";\n\n  & svg {\n    stroke-width: 1.2px;\n    fill: transparent;\n\n    &.filled {\n      fill: #ff0;\n    }\n  }\n"
    ]);
    Rating_styles_templateObject = function() {
        return data;
    };
    return data;
}

const Rating_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e4d8715f-0"
})(Rating_styles_templateObject(), (p)=>p.theme.spacing.nano, (p)=>p.theme.font.medium, (p)=>p.theme.colors.primary);

;// CONCATENATED MODULE: ./src/themes/default/components/Card/components/Rating/index.tsx



const Rating_Rating = (param)=>{
    let { value =0  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Rating_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 1 && {
                    className: "filled"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 2 && {
                    className: "filled"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 3 && {
                    className: "filled"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 4 && {
                    className: "filled"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiStar */.nae, {
                ...value >= 5 && {
                    className: "filled"
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/themes/default/components/Card/styles.ts

function Card_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n\n  opacity: 0;\n\n  transition: opacity 0.3s;\n  will-change: opacity;\n\n  margin-top: auto;\n\n  > * {\n    flex: 1;\n  }\n\n  @media (max-width: 768px) {\n    opacity: 1;\n  }\n"
    ]);
    Card_styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  width: 100%;\n  background-color: ",
        ";\n\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n\n  padding: 10px;\n  gap: 10px;\n\n  border-radius: ",
        ";\n\n  text-align: center;\n\n  transition: box-shadow 0.3s, transform 0.3s;\n  will-change: box-shadow, transform;\n\n  &:hover {\n    transform: translateY(-",
        ");\n    box-shadow: 0 3px 11.83px 1.17px rgb(0 0 0 / 15%);\n\n    ",
        " {\n      opacity: 1;\n    }\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 100%;\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & svg {\n    width: 25%;\n    height: 25%;\n  }\n"
    ]);
    styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-position: center;\n  object-fit: contain;\n"
    ]);
    styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: 300;\n\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n"
    ]);
    styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: bold;\n\n  &.isDashed {\n    opacity: 0.65;\n    font-size: ",
        ";\n    font-weight: 500;\n    text-decoration: line-through;\n  }\n"
    ]);
    styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        ";\n\n  background-color: ",
        ";\n  color: ",
        ";\n\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: ",
        ";\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n\n  width: max-content;\n\n  > input {\n    height: 36px;\n    min-width: 28px;\n    max-width: 28px;\n    color: ",
        ";\n\n    border: none;\n    text-align: center;\n    background: none;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n\n    &[type='number'] {\n      -moz-appearance: textfield;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n  }\n\n  @media (max-width: 768px) {\n    & > span {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: inherit;\n\n  height: 100%;\n  min-width: 28px;\n  max-width: 28px;\n  color: ",
        ";\n\n  transition: opacity ease-in 0.3s;\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}

const styles_WrapperAction = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-0"
})(Card_styles_templateObject());
const Card_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-1"
})(styles_templateObject1(), (p)=>p.theme.colors.background, (p)=>p.theme.borderRadius, (p)=>p.theme.spacing.small, styles_WrapperAction);
const styles_Proportional = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-2"
})(styles_templateObject2());
const WrapperNoImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-3"
})(styles_templateObject3(), (p)=>p.theme.colors.backgroundHover, (p)=>p.theme.colors.primary);
const Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-5f6719e4-4"
})(styles_templateObject4());
const styles_WrapperContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-5"
})(styles_templateObject5(), (p)=>p.theme.spacing.small);
const styles_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-6"
})(styles_templateObject6(), (p)=>p.theme.font.small);
const styles_Price = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-7"
})(styles_templateObject7(), (p)=>p.theme.font.medium, (p)=>p.theme.colors.textSecondary, (p)=>p.theme.font.small);
const styles_Flag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-8"
})(styles_templateObject8(), (p)=>p.theme.spacing.medium, (p)=>p.theme.colors.primary, (p)=>p.theme.colors.textLight, (p)=>p.theme.spacing.small, (p)=>p.theme.spacing.small, (p)=>p.theme.borderRadius);
const styles_Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5f6719e4-9"
})(styles_templateObject9(), (p)=>p.theme.colors.textSecondary);
const styles_WrapperPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-10"
})(_templateObject10(), (p)=>p.theme.spacing.small);
const WrapperQuantity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5f6719e4-11"
})(_templateObject11(), (p)=>p.theme.borderRadius, (p)=>p.theme.colors.border, (p)=>p.theme.colors.primary, (p)=>p.theme.font.medium);
const ButtonAction = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5f6719e4-12"
})(_templateObject12(), (p)=>p.theme.colors.primary);

;// CONCATENATED MODULE: ./src/themes/default/components/Card/index.tsx
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 








const Card = (param)=>{
    let { product , onClickProduct , onClickAddCart , quantityInBag , informQuantityAtProductCard  } = param;
    const { storeSettings  } = (0,useSiteSettings/* useSiteSettings */.h)();
    const [productInStock, setProductInStock] = (0,react.useState)(0);
    const [quantity, setQuantity] = (0,react.useState)(1);
    const { variations  } = product || {};
    const hasManyVariations = ((variations === null || variations === void 0 ? void 0 : variations.length) || 0) >= 1;
    let buttonTitle = "";
    let values;
    if (hasManyVariations) {
        var ref, ref1;
        const cheaperVariation = (ref = variations === null || variations === void 0 ? void 0 : variations.sort((currentVari, nextVari)=>{
            if (currentVari.promotionalPrice && nextVari.promotionalPrice && currentVari.promotionalPrice < nextVari.promotionalPrice) return -1;
            if (currentVari.promotionalPrice && !nextVari.promotionalPrice && currentVari.promotionalPrice < nextVari.price) return -1;
            if (nextVari.promotionalPrice && !currentVari.promotionalPrice && currentVari.price < nextVari.promotionalPrice) return -1;
            if (currentVari.price < nextVari.price) return -1;
            if (currentVari.price > nextVari.price) return 1;
            return 0;
        })) === null || ref === void 0 ? void 0 : ref[0];
        values = {
            name: product === null || product === void 0 ? void 0 : product.name,
            price: cheaperVariation === null || cheaperVariation === void 0 ? void 0 : cheaperVariation.price,
            promotionalPrice: cheaperVariation === null || cheaperVariation === void 0 ? void 0 : cheaperVariation.promotionalPrice,
            pictures: (ref1 = variations[0]) === null || ref1 === void 0 ? void 0 : ref1.pictures
        };
        buttonTitle = "VER VARIA\xc7\xd5ES";
    } else {
        values = product;
        buttonTitle = (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.blockOutOfStockProducts) && (!values.stock || productInStock <= 0) ? "ESGOTADO" : "COMPRAR";
    }
    const { name , price , discount , promotionalPrice , pictures , stock  } = values || {};
    (0,react.useEffect)(()=>{
        if (hasManyVariations && !quantityInBag) return;
        setProductInStock((stock || 0) - quantityInBag(product));
    }, [
        stock,
        quantityInBag,
        product,
        hasManyVariations
    ]);
    const addOneOnQuantity = (number, event)=>{
        if (stock === 0) return;
        event.stopPropagation();
        setQuantity((prev)=>prev + number);
    };
    const handleChangeQuantity = (event)=>{
        if (stock === 0) return;
        const newQuantity = Number(event.target.value);
        if (!newQuantity) {
            setQuantity(0);
            return;
        }
        if (productInStock <= quantity) {
            setQuantity(productInStock);
            return;
        }
        setQuantity(newQuantity);
    };
    const onClickButton = (e)=>{
        if (buttonTitle === "COMPRAR") {
            e.stopPropagation();
            onClickAddCart === null || onClickAddCart === void 0 ? void 0 : onClickAddCart(quantity);
        }
    };
    const isOutOfStock = (0,react.useMemo)(()=>{
        return hasManyVariations && (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.blockOutOfStockProducts) && productInStock <= 0;
    }, [
        hasManyVariations,
        productInStock,
        storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.blockOutOfStockProducts
    ]);
    if (!product) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_styles_Wrapper, {
        onClick: onClickProduct,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Proportional, {
                children: [
                    (pictures === null || pictures === void 0 ? void 0 : pictures[0]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        src: pictures[0]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperNoImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoImageOutline */.tpQ, {})
                    }),
                    discount && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Flag, {
                        children: discount
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating_Rating, {
                value: product.ratingAverage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_WrapperContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_WrapperPrice, {
                        children: hasManyVariations ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Label, {
                                    children: "A partir de"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Price, {
                                    children: (0,formatCurrency/* formatCurrency */.x)(((promotionalPrice || 0) > 0 && promotionalPrice !== price ? promotionalPrice : price) || 0)
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Price, {
                                    className: (promotionalPrice || 0) > 0 && promotionalPrice !== price ? "isDashed" : "",
                                    children: (0,formatCurrency/* formatCurrency */.x)(price || 0)
                                }),
                                (promotionalPrice || 0) > 0 && promotionalPrice !== price && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Price, {
                                    children: (0,formatCurrency/* formatCurrency */.x)(promotionalPrice || 0)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_WrapperAction, {
                children: [
                    !hasManyVariations && buttonTitle === "COMPRAR" && informQuantityAtProductCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperQuantity, {
                        onClick: (ev)=>ev.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAction, {
                                onClick: (ev)=>addOneOnQuantity(-1, ev),
                                disabled: isOutOfStock || quantity <= 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiMinus */.ego, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "number",
                                value: quantity,
                                disabled: isOutOfStock,
                                onClick: (ev)=>ev.stopPropagation(),
                                onChange: handleChangeQuantity
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAction, {
                                onClick: (ev)=>addOneOnQuantity(1, ev),
                                disabled: hasManyVariations && (storeSettings === null || storeSettings === void 0 ? void 0 : storeSettings.blockOutOfStockProducts) ? stock === 0 || productInStock <= quantity : false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiPlus */.OvN, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        onClick: onClickButton,
                        disabled: isOutOfStock,
                        font: "small",
                        children: buttonTitle
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Card = (Card);

;// CONCATENATED MODULE: ./src/themes/default/components/ProductsList/styles.ts

function ProductsList_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: grid;\n  grid-auto-rows: auto;\n  grid-auto-columns: max-content;\n  grid-template-columns: ",
        ";\n  grid-gap: ",
        ";\n\n  @media (max-width: 768px) {\n    grid-gap: ",
        ";\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media (max-width: 568px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    ProductsList_styles_templateObject = function() {
        return data;
    };
    return data;
}

const ProductsList_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d5d593b3-0"
})(ProductsList_styles_templateObject(), (param)=>{
    let { initialColumnItemsCount  } = param;
    return "repeat(".concat(initialColumnItemsCount, ", 1fr)");
}, (p)=>p.theme.spacing.xLarge, (p)=>p.theme.spacing.large);

;// CONCATENATED MODULE: ./src/themes/default/components/ProductsList/index.tsx
/* eslint-disable react/no-array-index-key */ 



const ProductsList = (param)=>{
    let { products , onClickProduct , onClickAddCart , isLoading , shimmerEffectQuantity =3 , initialColumnItemsCount =4 , quantityInBag , informQuantityAtProductCard , lastProductRef  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsList_styles_Wrapper, {
        initialColumnItemsCount: initialColumnItemsCount,
        children: [
            isLoading && [
                ...Array(shimmerEffectQuantity)
            ].map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSkeleton_CardSkeleton, {}, String(index))),
            !isLoading && (products === null || products === void 0 ? void 0 : products.map((product, index)=>{
                if (products.length === index + 1) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: lastProductRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Card, {
                            product: product,
                            quantityInBag: quantityInBag,
                            onClickProduct: ()=>{
                                return onClickProduct === null || onClickProduct === void 0 ? void 0 : onClickProduct(product);
                            },
                            onClickAddCart: (quantity)=>{
                                return onClickAddCart === null || onClickAddCart === void 0 ? void 0 : onClickAddCart(product, quantity);
                            },
                            informQuantityAtProductCard: informQuantityAtProductCard
                        }, product._id)
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Card, {
                    product: product,
                    quantityInBag: quantityInBag,
                    onClickProduct: ()=>{
                        return onClickProduct === null || onClickProduct === void 0 ? void 0 : onClickProduct(product);
                    },
                    onClickAddCart: (quantity)=>{
                        return onClickAddCart === null || onClickAddCart === void 0 ? void 0 : onClickAddCart(product, quantity);
                    },
                    informQuantityAtProductCard: informQuantityAtProductCard
                }, product._id);
            }))
        ]
    });
};
/* harmony default export */ var components_ProductsList = (ProductsList);


/***/ }),

/***/ 2894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
function formatCurrency(number) {
    return Intl.NumberFormat("pt-br", {
        currency: "BRL",
        style: "currency"
    }).format(number);
}


/***/ })

}]);